import { ChangeDetectionStrategy, Component, computed, DestroyRef, effect, inject, input, signal } from '@angular/core';
import { ProgressBarComponent } from '@shared/components/progress-bar';
import { StarRatingDisplayComponent } from '@shared/components/star-rating-display';
import { FindByPropertyPipe } from '@shared/pipe';
import { LogsService } from '@shared/services/logs';
import { ReviewsService } from '@shared/services/reviews';
import { UrlParamsService } from '@shared/services/url-params';
import { RatingDistribution } from '@shared/services/reviews/models';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-rating-distribution',
  imports: [StarRatingDisplayComponent, ProgressBarComponent, FindByPropertyPipe],
  templateUrl: './app-rating-distribution.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppRatingDistributionComponent {
  readonly storeUuid = input<string | null>(null);
  readonly reviewsPercentages = signal<RatingDistribution[] | null>(null);
  private readonly reviewsService = inject(ReviewsService);
  private readonly urlParamsService = inject(UrlParamsService);
  currentReviewNote = computed(() => Number(this.urlParamsService.param('review_note')() ?? '-1'));
  private readonly destroyRef = inject(DestroyRef);
  private readonly logs = inject(LogsService);

  constructor() {
    effect(() => {
      const storeUuid = this.storeUuid();
      const ratingDistributions = storeUuid
        ? this.reviewsService.getPercentageByRate(storeUuid)
        : this.reviewsService.getPercentageByRate();
      ratingDistributions
        .pipe(
          take(1),
          takeUntilDestroyed(this.destroyRef),
          tap((ratingDistributions) => {
            this.reviewsPercentages.set(ratingDistributions);
          })
        )
        .subscribe({
          error: (err) => this.logs.error('AppRatingDistributionComponent', 'getPercentageByRate failed', err),
        });
    });
  }

  onRatingSelected(note: number): void {
    this.urlParamsService.mergeParams({ review_note: note, review_page: 1 });
  }
}
